import { RouteConfig } from 'vue-router'
import DashboardLayout from "@/layout/DashboardLayout.vue";
import FirstPage from "@/views/Dashboard/FirstPage.vue";
import CustomerInfo from "@/views/Dashboard/CustomerInfo.vue";
import AddressBook from "@/views/Dashboard/AddressBook.vue";
import Orders from "@/views/Dashboard/Orders.vue";
import Reviews from "@/views/Dashboard/Reviews.vue";
import Wishlist from "@/views/Dashboard/Wishlist.vue";
import Messages from "@/views/Dashboard/Messages.vue";
import Notifications from "@/views/Dashboard/Notifications.vue";
import Prepays from "@/views/Dashboard/Prepays.vue";
import OrderSingle from "@/views/Dashboard/OrderSingle.vue";


const routes: Array<RouteConfig> = [
  {
    path: '/customer/account',
    name: 'dashboard-first-page',
    component: FirstPage,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/customer/account/edit',
    name: 'customer-info',
    component: CustomerInfo,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/customer/address',
    name: 'customer-addressbook',
    component: AddressBook,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/customer/address/new',
    name: 'customer-address-new',
    component: AddressBook,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/customer/address/edit/id/:addressId',
    name: 'customer-address-edit',
    component: AddressBook,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/sales/order/history',
    name: 'customer-orders',
    component: Orders,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/sales/order/view/order_id/:orderId',
    name: 'customer-order-single',
    component: OrderSingle,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/review/customer',
    name: 'customer-reviews',
    component: Reviews,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/review/customer/view/id/:reviewId',
    name: 'customer-review-view',
    component: Reviews,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/wishlist',
    name: 'customer-wishlist',
    component: Wishlist,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/wishlist/index/index/wishlist_id/:wishlistId',
    name: 'customer-wishlist',
    component: Wishlist,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/notify/notification/messages',
    name: 'customer-messages',
    component: Messages,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/notify/notification/customer',
    name: 'customer-notifications',
    component: Notifications,
    meta: { layout: DashboardLayout }
  },
  {
    path: '/prepay/customer',
    name: 'customer-prepays',
    component: Prepays,
    meta: { layout: DashboardLayout }
  },
]

export default routes;
